import { render, staticRenderFns } from "./EditableItem.vue?vue&type=template&id=60db085a"
import script from "./EditableItem.vue?vue&type=script&lang=js"
export * from "./EditableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports